/* eslint-disable react/jsx-no-bind */
import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { DateRangeSelectorInputs } from '@kognitiv/bf-library';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import { intlShape } from 'react-intl';

function DateRangeSelector(props) {
    const {
        notAvailableDates, maxLengthOfStay, minLengthOfStay, onChangeDates,
        checkIn, checkOut, currentLanguage, minNightOffset, showBlockedDaysReferences, id, intl,
    } = props;

    const handleChange = ({ startDate, endDate }) => {
        const dates = { startDate, endDate };
        onChangeDates(id, dates);

    };

    return (
        // i18nLabel[bf.displayMode.totalPrice]
        // i18nLabel[bf.displayMode.avgPricePerNight]
        // i18nLabel[bf.displayMode.avgPerPersonPerNight]
        // i18nLabel[bf.checkIn]
        // i18nLabel[bf.checkOut]
        // i18nLabel[bf.stayDates]
        // i18nLabel[bf.arrivalsOnly]
        // i18nLabel[bf.departuresOnly]
        // i18nLabel[bf.noAvailability]
        // i18nLabel[bf.price.from]
        // i18nLabel[bf.minLosTooltip]
        // i18nLabel[bf.maxLosTooltip]
        // i18nLabel[hotel.rateManager.ratePlans.addEditRatePlan.closeForDeparture.label]
        // i18nLabel[bf.doneButtonDatePicker]
        // i18nLabel[seekda.chainmetacpc.reset]
        // i18nLabel[bf.cancel]
        <DateRangeSelectorInputs
            autoFocus
            showInputs
            currentLanguage={currentLanguage}
            checkIn={checkIn ? moment(checkIn, 'YYYY-MM-DD') : null}
            checkOut={checkOut ? moment(checkOut, 'YYYY-MM-DD') : null}
            maxCheckOutDate={moment().add(1, 'year').toString()}
            minLengthOfStay={minLengthOfStay}
            maxLengthOfStay={maxLengthOfStay}
            minNightOffset={minNightOffset}
            notAvailableDates={notAvailableDates}
            onChange={handleChange}
            showBlockedDaysReferences={showBlockedDaysReferences}
            intl={intl}
        />
    );
}
DateRangeSelector.defaultProps = {
    notAvailableDates : [],
    minNightOffset    : 0,
    showBlockedDaysReferences: true,
};

DateRangeSelector.propTypes = {
    notAvailableDates : PropTypes.arrayOf(PropTypes.object),
    minNightOffset    : PropTypes.number,
    onChangeDates     : PropTypes.func.isRequired,
    currentLanguage   : PropTypes.string.isRequired,
    checkIn           : PropTypes.string.isRequired,
    checkOut          : PropTypes.string.isRequired,
    maxLengthOfStay   : PropTypes.number.isRequired,
    minLengthOfStay   : PropTypes.number.isRequired,
    showBlockedDaysReferences: PropTypes.bool,
    id                : PropTypes.string.isRequired,
    translations      : PropTypes.object,
    intl              : intlShape.isRequired,
};

const mapStateToProps = (state) => {
    const translations = state.translations.data;
    const language = state.search.data.language;
    const intlProvider = new IntlProvider({ locale: language, messages: translations });
    const intl = intlProvider.getChildContext();
    return {
        currentLanguage: language,
        translations,
        intl: intl.intl,
    };
};

const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(DateRangeSelector);


